var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_541)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11.8125C18.8252 11.8125 17.0625 13.5752 17.0625 15.75C17.0625 17.9248 18.8252 19.6875 21 19.6875C23.1748 19.6875 24.9375 17.9248 24.9375 15.75C24.9375 13.5752 23.1748 11.8125 21 11.8125ZM21 22.3125C17.3762 22.3125 14.4375 19.3751 14.4375 15.75C14.4375 12.1249 17.3762 9.1875 21 9.1875C24.6238 9.1875 27.5625 12.1249 27.5625 15.75C27.5625 19.3751 24.6238 22.3125 21 22.3125ZM21 0C12.3021 0 5.25 7.05206 5.25 15.75C5.25 22.3361 18.3816 42.0144 21 42C23.5777 42.0144 36.75 22.2469 36.75 15.75C36.75 7.05206 29.6979 0 21 0Z",
    fill: "#21A6E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem6);
export default __webpack_public_path__ + "static/media/item6.a76477e42d10abe6ae1a7bba58d79701.svg";
export { ForwardRef as ReactComponent };